import { render, staticRenderFns } from "./ExchangeMsg.vue?vue&type=template&id=3b0a3016&scoped=true&"
import script from "./ExchangeMsg.vue?vue&type=script&lang=js&"
export * from "./ExchangeMsg.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeMsg.vue?vue&type=style&index=0&id=3b0a3016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a3016",
  null
  
)

export default component.exports